import React from 'react';
import {Image} from 'react-native';
import {FontIcon, SimpleFontIcon} from '@/styles/common/FontIcon.jsx';
import {style} from './Style.jsx';
import {
  faClose,
  faMoon,
  faNavicon,
  faSun,
} from '@fortawesome/free-solid-svg-icons';
import {getDevice} from '@/services/utility.js';
import {Device} from '@/models/device';
import {PhoneView, MyView} from '@/styles/CommonComponents.jsx';
import {globalStateContext} from '@/App.jsx';
import {useTheme} from 'styled-components';
const Logo = props => {
  const device = getDevice();
  const useGlobalState = () => [React.useContext(globalStateContext)];
  const [state] = useGlobalState();
  const theme = useTheme();

  if (!props.isLogin) return <></>;
  return (
    <PhoneView
      style={
        state.isInPhone
          ? {
              ...style.Logo,
              ...style.LogoJustPhone,
            }
          : {
              ...style.Logo,
              ...style.LogoJustLarge,
              backgroundColor: theme.colors.base_500,
            }
      }>
      {props.toggleTheme && (
        <>
          <SimpleFontIcon
            onPress={() => {
              if (theme.name === 'dark') {
                localStorage.setItem('darkMode', false);
                localStorage.setItem('themeName', 'light');
                window.location.reload();
              }
            }}
            kind={'normal'}
            style={{
              color: theme.name === 'dark' ? 'unset' : theme.colors.warning,
              cursor: 'pointer',
            }}
            onClick
            icon={faSun}
          />
          <SimpleFontIcon
            kind={'normal'}
            onPress={() => {
              if (theme.name !== 'dark') {
                localStorage.setItem('darkMode', true);
                localStorage.setItem('themeName', 'dark');
                window.location.reload();
              }
            }}
            style={{
              color: theme.name === 'dark' ? theme.colors.primary : 'unset',
              cursor: 'pointer',
            }}
            icon={faMoon}
          />
        </>
      )}

      <Image
        resizeMode="contain"
        style={
          state.isInPhone
            ? [
                {
                  ...style.LogoImage,
                  ...style.LogoImageJustPhone,
                },
              ]
            : [
                {
                  ...style.LogoImage,
                  ...style.LogoImageJustLarge,
                },
              ]
        }
        source={require('./../../../../images/irysc.png')}
      />

      {props.isLogin && (
        <MyView
          style={{
            width: 40,
            height: 40,
            alignSelf: 'center',
          }}>
          {!state.isRightMenuVisible && state.isFilterMenuVisible && (
            <FontIcon
              style={{
                padding: device.indexOf(Device.App) === -1 ? 7 : 15,
              }}
              onPress={e => props.toggleRightMenuVisibility()}
              icon={faClose}
              back={'yellow'}
            />
          )}
          {(state.isRightMenuVisible || !state.isFilterMenuVisible) && (
            <FontIcon
              style={{
                padding: device.indexOf(Device.App) === -1 ? 7 : 15,
              }}
              onPress={e => props.toggleRightMenuVisibility()}
              icon={faNavicon}
            />
          )}
        </MyView>
      )}
    </PhoneView>
  );
};
export default Logo;
